// DASH_STATS_2810 (GROK2 28/10): números da home sem DataCrazy. 404 = switch
// private/DASH_STATS_2810_OFF ligado → tudo volta ao comportamento antigo.
import axios from 'axios';
import { API_BASE_URL } from '../apiBase';

let inflight = null;
export function fetchDashStats() {
  if (!inflight) {
    inflight = axios.get(`${API_BASE_URL}/api/aurax/dash-stats`, { withCredentials: true, timeout: 20000 })
      .then(({ data }) => ({ on: true, data }))
      .catch((e) => ({ on: e?.response?.status !== 404, data: null }))
      .finally(() => { setTimeout(() => { inflight = null; }, 0); });
  }
  return inflight;
}
